import { cx } from '@emotion/css';
import { ArrowDropDownRounded, ArrowDropUpRounded } from '@mui/icons-material';
import { Button, Variant } from '@sortlist-frontend/design-system/legacy';
import { FC, forwardRef, ReactNode, Ref } from 'react';

import { ExploreDropdownToggle } from '../types';

export type DropdownButtonProps = {
  children: ReactNode;
  className?: string;
  id: string;
  isOpenServices: ExploreDropdownToggle | undefined;
  label: string;
  openDropdown?: (param: string) => void;
  variant?: Variant;
};

export const DropdownButton = forwardRef<HTMLDivElement, DropdownButtonProps>((props, ref) => {
  const { children, id, isOpenServices, label, openDropdown, className } = props;
  return (
    <div ref={ref} data-testid={id} id={id} className={cx(className)}>
      <div
        className={cx(
          isOpenServices?.[id] ? 'bg-primary-200 text-primary-500' : 'bg-secondary-200 text-secondary-700',
          'width-100 layout-row layout-align-start-center cursor-pointer rounded-sm pl-4 pr-2 py-2',
        )}
        role="button"
        tabIndex={0}
        onKeyDown={() => {
          openDropdown?.(id);
        }}
        onClick={() => {
          openDropdown?.(id);
        }}>
        <span className="flex-1">{label}</span>
        {isOpenServices?.[id] ? (
          <ArrowDropUpRounded className="text-primary-500" />
        ) : (
          <ArrowDropDownRounded className="text-secondary-500" />
        )}
      </div>
      {children}
    </div>
  );
});
